<template>
  <IconLucideFolderSearch2 />
</template>
